import { wait } from '../../util/async.ts'
import { status } from '../../config.ts'
import { uninstallAppData, uninstalledData } from './data.ts'

export default [
  {
    method: 'GET',
    path: '/devices/123/uninstall-app-data',
    reply: async () => {
      await wait()
      return [status.ok, uninstallAppData]
    }
  },
  {
    method: 'GET',
    path: '/devices/123/uninstall-app',
    reply: async () => {
      await wait()
      return [status.ok, uninstalledData]
    }
  }
]
